export class appNotificationText{
    _id:any;
    notificationTextId:any;
    notificationTitle:any;
    notificationType:any;
    notificationTextDescription:any;
    status:any;
}